export const CatalogueLang = {
  CATALOGUE_1: "400x400mm Tiles catalogues",
  CATALOGUE_2: "500x500mm Tiles catalogues",
  E_CATALOGUE: "E - Catalogue",

  VISIT_OTHER: "Visit Other Collections",
  CATALOGUE: "CATALOGUE",
};
